module.exports = "/images/vendor/desiigner-svg/svg/places/team.svg?3111bf0949d86c7a832321711d5883b6";